module.exports = __webpack_public_path__ + "img/Binary Tree.dc388779.svg";